import { render, staticRenderFns } from "./Insight_Card.vue?vue&type=template&id=203506ca&scoped=true"
import script from "./Insight_Card.vue?vue&type=script&lang=js"
export * from "./Insight_Card.vue?vue&type=script&lang=js"
import style0 from "./Insight_Card.vue?vue&type=style&index=0&id=203506ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203506ca",
  null
  
)

export default component.exports